// extracted by mini-css-extract-plugin
export default {"price":"d5-z","priceRow":"e5-z","onSale":"f5-z","msrpLabelPrice":"g5-z","msrpLabel":"h5-z","originalPrice":"i5-z","percentOff":"j5-z"};